import { useEffect, useState } from 'react'

import { useNavigate } from 'react-router'
import { useReplaceMembers } from 'src/legacy_modules/entities/member/atom'
import { fetch as fetchMembers } from 'src/legacy_modules/entities/member/request'
import { routes } from 'src/legacy_modules/routes'

export const useInit = (trialUid: string) => {
  const [initialized, setInitialized] = useState(false)
  const navigate = useNavigate()
  const replaceMembers = useReplaceMembers()

  useEffect(() => {
    const fetch = async () => {
      try {
        const members = await fetchMembers({ trialUid, type: 'all' })
        replaceMembers(members)
        setInitialized(true)
      } catch (error) {
        // TOOD: login key?
        console.error('userActions.fetchList Error: ', error)
        error.original.response.status === 403
          ? navigate(routes.httpError403)
          : navigate(`${routes.requiredLogin}`)
      }
    }

    fetch()
  }, [navigate, replaceMembers, setInitialized, trialUid])

  return {
    initialized,
  }
}
